import { gql } from "@apollo/client";

const ENTRIES = gql`
  query tournamentRegistrations($filter: ListTournamentRegistrationInput) {
    tournamentRegistrations(filter: $filter) {
      id
      type
      status
      rankType
      assignedSegment
      additionalSegment
      seed
      amount
      paymentMethod
      categoryId {
        mdwc
        qwc
        qs
      }
      team {
        title
        country
        image
      }
      users {
        id
        user {
          rank
          id
          name
          phone
          surname
          avatar
          nation
          email
          gender
          dob
        }
      }
    }
  }
`;

export default ENTRIES;
